import { createApp } from 'vue'
import { RouterView } from 'vue-router'
import { createPinia } from 'pinia'
import router from '../spa/router'
import '../spa/spa.scss'

const app = createApp(RouterView)

if (import.meta.env.PROD && import.meta.env.VITE_BUGSNAG_KEY) {
  const Bugsnag = (await import('@bugsnag/js')).default
  const BugsnagPluginVue = (await import('@bugsnag/plugin-vue')).default

  Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()],
    releaseStage: import.meta.env.VITE_BUGSNAG_RELEASE_STAGE || 'production',
  })

  app.use(Bugsnag.getPlugin('vue'))
}

app.use(createPinia())
app.use(router)
app.mount('#app')
